import { axiosInstance } from '../Middleware'
import { LoadActualite } from './types'

export class ActualiteApi {
  public static loadActualite = (complement?: string, silent?: boolean) : Promise<LoadActualite[]> => {
    let url = '/personnel/personnel/actualites';

    if (complement) {     
      url += complement;
    }
 
    return axiosInstance.get(url, silent ? { silent: true } as any : undefined)
      .then(response => response.data.data)
      .catch((error) => console.error("Erreur lors de la connexion :", error));
  }
}